var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipseSafetyAirbags3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 453,
    viewBox: "0 0 538 453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.238 171.741C223.276 171.694 231.009 171.081 233.319 170.986C235.253 170.892 236.149 171.646 236.29 173.533C236.337 174.146 236.384 174.853 236.432 175.56C236.526 176.173 236.573 176.833 236.62 177.541C237.139 183.953 237.988 193.007 238.931 203.71C239.544 210.265 240.204 217.432 240.911 224.976C241.666 233.181 242.467 241.857 243.269 250.675C244.683 265.528 246.145 280.947 247.512 295.612C249.021 311.644 250.436 326.78 251.568 339.322C251.568 340.03 251.709 340.737 251.756 341.444H251.803C253.312 358.184 254.35 369.925 254.444 372.377L237.94 372.235V371.622C237.469 364.596 236.526 353.515 235.347 340.124C235.064 337.153 234.828 334.088 234.498 330.929C233.131 315.557 231.48 297.969 229.783 280.24C228.981 271.847 228.18 263.5 227.378 255.296C226.482 245.677 225.539 236.34 224.738 227.617C223.889 218.941 223.087 210.925 222.38 203.852C221.154 191.309 220.211 181.926 219.787 177.635C219.645 176.173 219.551 175.324 219.551 175.136C219.174 172.071 220.682 171.835 222.238 171.741Z",
    fill: "#36393B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.86 184.425C251.664 189.282 249.919 195.034 250.202 202.767C247.986 203.239 243.601 203.522 238.933 203.71C237.989 193.007 237.141 183.953 236.622 177.541C241.856 179.097 248.505 181.549 255.86 184.425Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.471 110.772L133.875 118.788C130.244 120.156 125.151 122.513 121.473 124.635L102.518 119.401L84.4111 114.45V113.46L98.5099 109.735L102.518 110.772",
    fill: "#36393B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3645 114.45L102.471 119.401C102.33 120.438 101.057 120.91 99.925 120.957C99.6892 120.957 99.4534 120.957 99.1705 121.004C94.7381 121.146 86.2035 121.476 82.9028 121.57H82.054C79.6492 121.57 77.9988 119.495 77.8574 116.713C77.7159 113.979 78.9891 106.67 80.9223 103.746C82.9028 100.823 86.4392 99.031 91.1545 99.2196C95.8698 99.3611 97.6616 100.351 98.9348 101.954C100.255 103.605 101.764 106.764 102.471 110.772L98.4632 109.735L84.3645 113.46V114.45Z",
    fill: "#36393B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1706 121.005C100.397 138.735 107.234 217.15 108.271 234.55L107.422 235.493C101.245 229.976 95.4455 224.883 90.3058 220.545L91.1546 219.555C89.8815 201.448 85.0719 138.546 82.9028 121.571C86.2035 121.477 94.7382 121.147 99.1706 121.005Z",
    fill: "#36393B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.547 141.469C287.075 150.947 289.433 159.152 293.959 164.999C290.517 170.374 284.953 176.975 282.36 179.239C276.843 176.975 271.232 174.853 265.809 172.873C264.819 154.766 272.411 132.982 282.03 113.932C283.256 111.433 284.576 108.934 285.943 106.529C290.8 97.7584 295.893 89.8367 300.561 83.5182C306.031 76.0209 310.887 70.7398 313.905 68.8536C325.411 61.5921 332.672 61.4978 343.8 63.101C362.237 65.7887 400.619 74.2291 413.256 79.6045C420.282 82.5752 425.799 85.9702 431.08 90.1196C423.63 84.8856 413.681 91.9586 410.946 95.3536C397.932 111.433 387.181 125.673 379.495 138.687C378.033 141.139 376.619 144.157 375.204 147.552C369.168 162.216 363.793 184.001 362.237 197.393C360.304 213.896 358.135 241.811 359.596 261.426C355.023 249.167 348.987 233.37 344.979 223.421H344.932C343.517 219.79 342.386 217.008 341.631 215.405C339.886 211.633 337.152 208.709 333.898 206.87C328.57 202.249 320.601 197.345 311.265 192.489C313.905 188.009 317.159 185.51 321.544 185.887C325.976 186.265 329.796 183.2 331.54 180.135C333.238 177.07 335.36 170.94 340.358 169.007C339.792 161.509 339.698 155.191 339.981 148.684C340.924 126.805 328.947 118.93 315.791 116.62C301.41 114.12 288.961 124.306 287.594 139.866C287.547 140.385 287.5 140.951 287.5 141.469",
    fill: "#727272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.128 90.1185C435.372 93.372 439.427 97.1443 444.001 101.482C450.743 107.848 458.194 116.807 465.455 127.464C474.744 141.044 483.751 157.359 490.446 174.381C488.513 176.456 486.485 178.342 484.552 179.945C481.817 182.303 479.318 184.141 477.762 185.509C475.074 187.819 472.387 187.819 469.699 187.442C469.558 187.442 469.416 187.442 469.275 187.442C466.634 187.301 463.05 188.998 460.881 190.554C459.844 191.309 458.712 192.157 457.534 193.101C452.63 196.873 446.547 202.154 441.077 208.048C438.955 210.359 436.928 212.763 435.089 215.215C434.099 216.583 433.108 217.997 432.26 219.412C431.599 220.402 430.986 221.439 430.468 222.477C427.969 226.768 424.385 232.756 419.905 235.114C419.151 235.538 418.349 235.821 417.548 236.01C417.595 235.35 417.595 234.689 417.548 234.124C417.406 231.625 416.558 229.927 415.52 229.267C414.436 228.607 413.21 228.984 412.55 230.729C411.041 234.548 406.938 241.621 406.043 243.083C405.194 244.544 404.298 246.902 404.298 248.364C404.298 249.826 403.119 251.617 401.657 252.796C400.196 253.975 373.413 272.176 370.489 273.638C367.519 275.147 364.218 274.015 363.133 270.997C362.143 268.309 360.964 265.056 359.644 261.519C358.182 241.857 360.351 213.942 362.285 197.439C363.841 184.047 369.216 162.263 375.252 147.598C376.666 144.203 378.081 141.185 379.543 138.733C387.228 125.719 397.979 111.479 410.994 95.3996C413.728 92.0046 423.678 84.9317 431.128 90.1656",
    fill: "#727272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.64 139.865C289.007 124.304 301.456 114.119 315.837 116.618C328.993 118.929 340.97 126.803 340.027 148.682C339.744 155.189 339.838 161.508 340.404 169.005C335.406 170.939 333.284 177.068 331.587 180.133C329.842 183.198 326.022 186.263 321.59 185.886C317.205 185.509 313.951 188.008 311.311 192.487C305.841 189.611 299.9 186.782 293.723 184.047C296.552 181.454 302.682 172.825 305.558 168.534C301.456 166.035 296.882 164.809 293.958 164.997C289.432 159.15 287.074 150.946 287.546 141.515C287.546 140.949 287.593 140.383 287.64 139.865Z",
    fill: "#36393B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M430.467 222.431C431.505 229.032 431.175 234.549 429.901 239.264C428.44 244.64 425.799 248.93 422.64 252.467C420.094 255.296 417.312 257.701 414.577 259.776C412.879 262.18 410.616 264.868 407.928 267.65C395.103 281.23 373.507 297.828 366.952 302.732C359.031 308.626 344.885 313.624 337.529 296.555C337.246 295.942 336.963 295.188 336.586 294.386C334.558 289.388 331.399 281.136 327.862 271.753C322.393 257.324 316.169 240.443 311.972 229.221C309.237 221.959 309.001 211.585 317.017 207.011C317.442 206.729 317.913 206.493 318.432 206.257C323.854 203.899 329.419 204.324 333.945 206.87C337.199 208.709 339.934 211.632 341.678 215.405C342.433 217.008 343.564 219.79 344.979 223.374H345.026C349.034 233.37 355.07 249.166 359.644 261.426C360.964 265.01 362.143 268.263 363.133 270.951C364.217 273.969 367.518 275.1 370.489 273.591C373.412 272.13 400.195 253.929 401.657 252.75C403.119 251.571 404.297 249.779 404.297 248.317C404.297 246.856 405.193 244.498 406.042 243.036C406.938 241.575 411.04 234.502 412.549 230.682C413.209 228.938 414.435 228.56 415.52 229.221C416.557 229.881 417.406 231.578 417.547 234.077C417.595 234.643 417.595 235.303 417.547 235.963C418.349 235.775 419.151 235.492 419.905 235.068C424.385 232.71 427.968 226.721 430.467 222.431Z",
    fill: "#36393B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M483.891 140.242C487.003 146.372 493.887 159.81 495.821 163.252C497.707 166.695 494.925 169.995 490.445 174.381C483.749 157.358 474.743 141.043 465.454 127.463C473.187 130.623 480.826 134.112 483.891 140.242Z",
    fill: "#36393B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M151.982 72.4374C151.039 74.3706 150.379 76.3982 150.096 78.4729C149.907 79.6518 149.813 81.0663 149.719 82.6695C149.389 89.1295 149.907 98.0886 151.416 103.794C149.106 108.745 146.842 112.046 145.664 113.366C144.532 114.734 141.278 116.997 137.223 117.799C139.911 100.022 144.909 84.8857 151.746 72.2959L151.982 72.4374Z",
    fill: "#727272"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.716 105.773C154.104 115.864 151.464 121.428 147.786 126.992C142.222 135.432 133.593 156.132 134.159 173.437C134.724 190.695 135.903 206.822 136.281 213.895L141.326 215.828C140.854 216.582 140.383 217.384 139.911 218.138C135.479 225.636 136.516 238.037 141.562 246.619C140.241 254.305 139.77 260.765 144.909 266.706C151.417 274.25 162.215 288.396 173.909 304.617C162.403 289.575 147.314 273.496 132.131 258.69C126.614 253.315 121.144 248.081 115.769 243.129L116.712 242.092C119.258 196.542 115.675 162.121 112.61 141.373C111.902 136.564 114.166 130.623 117.231 127.558C118.079 126.709 119.541 125.719 121.427 124.634C125.105 122.512 130.198 120.155 133.829 118.834C135.196 118.316 136.375 117.938 137.176 117.797C141.232 116.995 144.485 114.732 145.617 113.365C146.796 112.044 149.059 108.744 151.369 103.792C154.104 103.792 156.886 104.453 159.668 105.773",
    fill: "#36393B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.664 164.81C172.352 175.891 183.244 206.069 189.28 218.565L186.686 219.932C185.319 217.244 183.621 214.698 181.688 212.435C177.303 207.107 172.163 203.004 169.098 201.26C163.534 198.1 156.603 199.326 152.783 201.825C149.388 203.995 144.767 210.219 141.325 215.83L136.28 213.897C135.902 206.824 134.724 190.697 134.158 173.439C133.592 156.134 142.221 135.434 147.785 126.994C151.463 121.43 154.104 115.866 159.715 105.775C166.505 108.981 172.87 116.101 176.171 126.428C175.039 129.116 175.794 132.935 178.482 134.868C181.169 136.802 183.48 138.122 184.611 139.961C183.951 139.961 183.338 140.102 182.725 140.244C176.171 141.753 166.599 152.126 169.664 164.81Z",
    fill: "#36393B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.707 58.622C197.862 61.2626 206.491 74.9369 206.114 86.9138C205.973 91.912 205.548 98.9849 204.935 107.803C201.305 108.981 194.42 119.874 190.742 123.74C187.112 127.56 181.548 128.361 176.172 126.428C172.871 116.101 166.506 108.981 159.716 105.775C156.934 104.455 154.152 103.795 151.417 103.795C149.908 98.089 149.389 89.13 149.719 82.7172C149.814 81.0668 149.908 79.6522 150.097 78.4734C150.379 76.3987 151.04 74.3711 151.983 72.4378C152.313 71.8248 152.643 71.2119 153.02 70.5989C157.924 62.7243 168.25 57.2546 181.548 58.1033C182.161 58.1033 182.773 58.1976 183.386 58.3391C183.858 58.3863 184.282 58.4806 184.707 58.622Z",
    fill: "#36393B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.928 28.5855C239.215 31.7919 250.343 38.6291 258.784 47.7768C256.615 49.5686 256.238 52.8221 257.982 55.1326C261.519 59.6593 264.536 64.8461 266.847 70.5516C259.302 68.6184 251.381 69.75 243.883 73.3337C242.516 70.6459 241.054 68.3354 239.687 66.4022C229.502 52.162 212.668 43.7216 196.825 44.9004C193.901 45.1362 191.685 47.6824 191.874 50.6531C191.874 50.7945 191.921 50.936 191.968 51.0775C189.752 51.6433 187.63 52.4449 185.744 53.5294L184.706 58.6219C184.282 58.4805 183.858 58.3862 183.386 58.339C182.773 58.1976 182.16 58.1504 181.547 58.1032C168.25 57.2545 157.924 62.7242 153.02 70.5988C152.642 71.2118 152.312 71.8248 151.982 72.4377L151.747 72.2963C152.077 71.6833 152.407 71.0703 152.737 70.4573C169.9 39.8079 197.391 24.9547 224.834 24.436L224.928 28.5855Z",
    fill: "#727272"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M285.99 106.481C284.622 108.933 283.302 111.432 282.076 113.931C277.549 110.3 262.46 105.396 251.002 102.049C250.672 93.4668 249.116 86.3467 246.994 80.4526C253.313 77.3876 259.961 76.5389 266.233 78.4721C267.647 78.8965 268.967 79.4624 270.241 80.1696C272.457 87.9027 273.636 96.2488 273.73 104.972C273.73 107.943 276.135 110.3 279.058 110.3C282.029 110.253 284.386 107.848 284.339 104.878C284.339 102.709 284.245 100.54 284.056 98.4178C284.905 100.964 285.565 103.652 285.99 106.481Z",
    fill: "#727272"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M317.017 207.011C306.927 205.549 278.352 193.148 255.86 184.424C248.504 181.548 241.856 179.096 236.622 177.54C236.575 176.833 236.527 176.173 236.433 175.56C238.319 175.465 238.555 173.626 238.555 172.448C238.555 171.269 238.178 167.072 237.989 164.102C245.911 166.129 255.577 169.194 265.809 172.872C271.232 174.852 276.843 176.974 282.36 179.238C286.179 180.794 289.999 182.397 293.724 184.047C299.901 186.782 305.842 189.611 311.312 192.488C320.648 197.344 328.617 202.248 333.945 206.869C329.419 204.323 323.855 203.899 318.432 206.256C317.913 206.492 317.442 206.728 317.017 207.011Z",
    fill: "#36393B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M250.955 102.05C262.413 105.398 277.502 110.302 282.029 113.932C272.409 132.982 264.818 154.767 265.808 172.874C255.576 169.196 245.909 166.131 237.988 164.103C237.799 161.651 235.536 158.539 232.282 156.747L232.801 155.898C233.461 156.181 234.168 156.323 234.876 156.323C236.95 156.323 238.931 155.097 239.78 153.069C248.644 132.369 251.379 115.488 250.955 102.05Z",
    fill: "#727272"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M258.784 47.7755C250.344 38.6278 239.216 31.7906 224.928 28.5842L224.834 24.4348C227.805 24.3405 230.775 24.4348 233.746 24.7177C268.686 27.9241 293.583 43.909 300.609 83.5174C295.941 89.8359 290.848 97.7576 285.991 106.481C285.567 103.652 284.907 100.964 284.058 98.4178C283.634 91.4391 282.502 84.6491 280.805 78.2835C278.023 68.0513 273.779 58.715 268.12 50.8404C267.555 50.086 266.989 49.3315 266.423 48.5771C264.631 46.2194 261.236 45.7951 258.926 47.634C258.926 47.6812 258.831 47.7283 258.784 47.7755Z",
    fill: "#727272"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222.381 203.852C223.088 210.925 223.89 218.941 224.739 227.617C218.561 228.56 212.997 229.362 209.932 229.645C201.492 230.399 196.494 230.399 191.543 222.713C190.93 221.77 190.175 220.356 189.279 218.564C183.244 206.068 172.352 175.89 169.664 164.809C166.599 152.125 176.171 141.752 182.725 140.243C183.338 140.101 183.951 140.007 184.611 139.96C191.071 139.3 199.842 142.789 202.294 153.257C204.934 164.809 212.243 194.704 213.799 198.571C215.308 202.39 217.996 203.805 222.381 203.852Z",
    fill: "#36393B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M266.845 70.5505C268.212 73.6155 269.297 76.8219 270.193 80.1697C268.92 79.4624 267.599 78.8966 266.185 78.4722C259.913 76.5389 253.265 77.3877 246.946 80.4526C246.05 77.8121 244.966 75.4544 243.881 73.3325C251.379 69.7489 259.3 68.6172 266.845 70.5505Z",
    fill: "#727272"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M255.859 184.424C278.351 193.148 306.926 205.549 317.017 207.011C309.001 211.584 309.236 221.958 311.971 229.22C316.168 240.442 322.392 257.323 327.862 271.752C326.683 275.241 324.844 286.369 323.335 296.554C322.062 305.372 321.072 313.435 321.072 315.085C321.072 318.669 321.638 323.761 322.628 326.308C324.042 329.985 324.75 337.624 324.467 347.809C317.111 351.959 302.163 349.365 292.497 344.556L291.79 345.027C278.163 323.95 261.659 308.437 251.851 299.525C251.851 299.478 251.757 299.43 251.71 299.383L252.37 298.676C253.879 285.85 254.115 263.406 253.973 247.798C253.926 239.358 253.737 232.945 253.549 231.153C253.313 228.701 253.077 225.73 252.794 222.713C252.464 219.506 252.087 216.205 251.521 213.282C250.767 209.368 250.295 205.879 250.201 202.767C249.918 195.034 251.663 189.281 255.859 184.424Z",
    fill: "#36393B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M250.201 202.768C250.295 205.88 250.767 209.369 251.521 213.283C252.087 216.206 252.464 219.507 252.794 222.713C250.578 223.232 246.146 224.034 240.912 224.977C240.204 217.432 239.544 210.265 238.931 203.711C243.599 203.522 247.985 203.239 250.201 202.768Z",
    fill: "#36393B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.789 177.636C220.213 181.927 221.156 191.31 222.382 203.853C217.997 203.806 215.309 202.391 213.8 198.572C212.244 194.705 204.935 164.81 202.295 153.258C199.843 142.79 191.072 139.3 184.612 139.96C183.481 138.121 181.17 136.801 178.483 134.868C175.795 132.935 175.04 129.115 176.172 126.428C181.547 128.361 187.112 127.559 190.742 123.74C194.42 119.873 201.305 108.981 204.935 107.802C205.548 98.9846 205.973 91.9116 206.114 86.9134C206.491 74.9365 197.862 61.2622 184.707 58.6216L185.744 53.5291C187.63 52.4446 189.752 51.643 191.968 51.0771C192.393 53.812 194.797 55.7453 197.627 55.5567C209.886 54.6608 222.948 61.3565 231.011 72.5789C232.426 74.6065 233.699 76.7284 234.783 78.9917C225.07 86.6776 216.865 98.5602 212.386 113.036C207.387 129.115 208 145.1 212.951 157.501L217.902 158.963C215.498 161.462 214.602 164.574 214.602 166.366C214.602 169.478 214.885 171.034 215.12 174.146C215.403 177.306 217.808 177.824 219.789 177.636Z",
    fill: "#727272"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 99.0312C241.243 113.507 237.895 130.435 229.973 148.872C228.795 151.607 230.068 154.719 232.803 155.898L232.284 156.746C230.539 155.756 228.465 155.143 226.343 155.238C222.476 155.426 219.741 156.982 217.902 158.963L212.951 157.501C208 145.1 207.387 129.115 212.385 113.036C216.865 98.5597 225.07 86.6771 234.783 78.9912C236.009 81.396 236.999 83.9423 237.754 86.5828C236.339 87.8088 234.972 89.1762 233.651 90.638C231.058 93.42 232.567 97.2394 237.565 98.4182C238.084 98.5597 238.933 98.7483 240.064 99.0312Z",
    fill: "#36393B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M280.803 78.284C282.5 84.6496 283.632 91.4397 284.056 98.4183C282.406 93.4672 280.048 89.1292 277.03 85.687C276.182 81.3961 275.05 77.1523 273.635 73.0972C276.229 74.4646 278.633 76.2093 280.803 78.284Z",
    fill: "#727272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M284.339 104.878C284.339 107.849 282.029 110.254 279.058 110.301H279.011C276.087 110.301 273.683 107.943 273.683 104.972C273.588 96.2491 272.41 87.903 270.193 80.1699C272.74 81.5374 275.003 83.4235 277.031 85.6868C280.048 89.129 282.406 93.4671 284.056 98.4181C284.245 100.54 284.292 102.709 284.339 104.878Z",
    fill: "#727272"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M273.636 73.097C275.05 77.1522 276.182 81.396 277.031 85.6869C275.003 83.4235 272.74 81.5374 270.194 80.17C269.298 76.8221 268.213 73.6157 266.846 70.5508C267.412 70.6451 267.977 70.7865 268.496 70.9752C270.288 71.541 272.033 72.2483 273.636 73.097Z",
    fill: "#727272"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M268.119 50.8409C273.777 58.7155 278.021 68.0517 280.803 78.2839C278.634 76.2092 276.229 74.4646 273.636 73.0971C270.288 63.6665 265.384 54.9904 258.783 47.776C258.783 47.7288 258.877 47.6817 258.924 47.6345C261.235 45.7956 264.63 46.2199 266.422 48.5776C266.987 49.332 267.553 50.0865 268.119 50.8409Z",
    fill: "#727272"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M258.782 47.7754C265.384 54.9898 270.288 63.6659 273.636 73.0965C272.032 72.2478 270.288 71.5405 268.496 70.9746C267.977 70.786 267.411 70.6446 266.846 70.5503C264.535 64.8448 261.517 59.6579 257.981 55.1312C256.236 52.8208 256.613 49.5672 258.782 47.7754Z",
    fill: "#727272"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M246.947 80.4531C249.069 86.3472 250.625 93.4673 250.955 102.049C249.022 101.483 247.183 100.965 245.532 100.493C245.202 94.0803 244.071 88.2805 242.279 83.1408C243.788 82.1035 245.344 81.2076 246.947 80.4531Z",
    fill: "#727272"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M243.882 73.332C244.967 75.4539 246.052 77.8116 246.947 80.4521C245.344 81.2066 243.788 82.1025 242.279 83.1398C241.431 80.5936 240.393 78.1416 239.214 75.8783C240.723 74.8881 242.326 74.0393 243.882 73.332Z",
    fill: "#727272"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M242.279 83.1401C244.071 88.2798 245.203 94.0796 245.533 100.492C243.364 99.9266 241.525 99.4079 240.063 99.0307C239.733 94.6455 238.978 90.4488 237.752 86.5823C239.214 85.3092 240.723 84.1303 242.279 83.1401Z",
    fill: "#727272"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M237.753 86.5821C236.998 83.9416 236.008 81.3953 234.782 78.9905C236.197 77.8589 237.706 76.8215 239.215 75.8784C240.393 78.1418 241.431 80.5937 242.28 83.14C240.723 84.1302 239.215 85.309 237.753 86.5821Z",
    fill: "#727272"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M229.973 148.872C237.895 130.435 241.243 113.507 240.064 99.0312C241.526 99.4085 243.365 99.9272 245.534 100.493C247.184 100.965 249.023 101.483 250.956 102.049C251.381 115.488 248.646 132.368 239.781 153.069C238.932 155.096 236.952 156.322 234.877 156.322C234.17 156.322 233.462 156.181 232.802 155.898C230.067 154.719 228.794 151.607 229.973 148.872Z",
    fill: "#727272"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M231.01 72.5774C222.947 61.355 209.885 54.6593 197.626 55.5552C194.796 55.7438 192.392 53.8105 191.967 51.0757C207.245 47.2091 228.652 55.2251 239.215 75.8781C237.706 76.8212 236.197 77.8585 234.782 78.9902C233.698 76.7269 232.425 74.605 231.01 72.5774Z",
    fill: "#727272"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M239.214 75.8778C228.652 55.2248 207.244 47.2088 191.967 51.0753C191.967 50.9339 191.873 50.7924 191.873 50.651C191.684 47.6803 193.9 45.1341 196.824 44.8983C212.667 43.7195 229.501 52.1599 239.686 66.4001C241.053 68.3333 242.515 70.6438 243.882 73.3315C242.326 74.0388 240.723 74.8876 239.214 75.8778Z",
    fill: "#727272"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M534.203 280.852C533.92 280.758 528.592 279.155 527.79 278.824C526.988 278.494 520.858 274.816 520.858 274.816C520.858 274.816 518.972 275.382 518.595 275.382C518.406 275.382 503.082 269.111 486.06 262.274C482.382 260.718 478.609 259.162 474.884 257.653C469.179 255.342 463.615 253.079 458.758 251.099C448.714 246.996 441.5 244.073 441.5 244.073",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M529.535 181.973C529.535 181.973 527.225 180.275 526.376 180.04C525.527 179.804 510.957 176.597 506.619 175.843C502.234 175.088 499.263 178.861 496.858 184.566C494.454 190.272 495.255 194.044 497.849 195.081C500.442 196.072 520.859 203.05 522.321 203.475C522.698 203.569 522.981 203.663 523.264 203.663C524.16 203.757 524.82 203.475 525.433 203.144C526.282 202.673 527.131 202.06 527.131 202.06C527.131 202.06 524.773 200.551 525.48 193.903C526.14 187.207 529.535 181.973 529.535 181.973Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M429.901 239.263C435.842 241.715 441.501 244.072 441.501 244.072",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M415.426 228.653C415.426 228.653 415.426 229.031 415.52 229.219",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M525.338 207.86C525.338 207.86 520.009 209.227 515.388 209.982C512.748 210.453 510.296 210.736 509.259 210.453C507.467 209.982 480.118 200.598 457.532 193.054",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M515.39 210.029C508.741 217.574 505.535 227.712 507.468 240.773C509.355 253.834 513.221 258.22 515.956 261.426C518.691 264.632 520.247 266.188 520.86 274.817",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M523.265 203.663L525.151 206.351L525.905 207.435L526.377 208.095C526.377 208.095 521.567 213.235 518.219 222.854C514.872 232.474 515.862 252.844 521.52 259.917C527.179 266.942 528.074 267.697 528.452 270.479C528.829 273.214 529.112 277.929 529.112 277.929",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M430.891 218.799C430.891 218.799 431.598 219.129 432.258 219.365C435.559 220.827 443.15 224.033 444.659 224.505C446.451 225.023 447.724 223.986 447.771 222.288C447.771 221.44 447.724 220.119 447.677 218.705C447.583 217.337 447.488 215.828 447.394 214.461C447.158 211.537 446.31 210.17 444.848 209.51C444.376 209.321 442.915 208.708 441.076 208.001",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M447.678 218.705C447.678 218.705 447.018 219.271 446.452 219.176C446.075 219.129 439.897 216.913 435.088 215.168",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M525.009 206.539H524.962C523.406 205.973 495.067 196.165 469.274 187.395",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M493.604 182.775C493.604 182.775 490.02 181.644 484.55 179.946",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M373.034 1C418.301 40.8442 468.943 89.2232 526.517 162.122C530.855 167.639 533.495 174.099 534.91 180.747C534.91 180.841 534.91 180.889 534.91 180.983C535.994 185.934 536.419 191.026 536.419 195.883C536.419 205.314 537.975 237.802 535.994 280.9C535.57 290.472 534.957 300.563 534.108 310.984C533.684 316.406 529.959 322.489 524.159 325.554C496.763 340.077 388.689 396.849 326.211 429.715C319.61 433.157 313.574 436.316 308.151 439.145C291.412 447.963 280.897 453.48 280.897 453.48",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M149.718 82.67C149.813 81.0668 149.907 79.6522 150.095 78.4734C150.378 76.3987 151.039 74.3711 151.982 72.4378C152.312 71.8248 152.642 71.2119 153.019 70.5989C157.923 62.7243 168.249 57.2546 181.547 58.1033C182.159 58.1033 182.772 58.1976 183.385 58.3391C183.857 58.3863 184.281 58.4806 184.706 58.622C197.861 61.2626 206.49 74.9369 206.113 86.9138C205.972 91.912 205.547 98.9849 204.934 107.803C201.304 108.981 194.419 119.874 190.741 123.74C187.111 127.56 181.547 128.361 176.171 126.428C175.039 129.116 175.794 132.935 178.482 134.868C181.169 136.802 183.48 138.122 184.611 139.961",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M121.473 124.635C125.151 122.513 130.243 120.156 133.874 118.835C135.241 118.317 136.42 117.94 137.222 117.798C141.277 116.997 144.53 114.733 145.662 113.366C146.841 112.045 149.104 108.745 151.415 103.794C149.906 98.0882 149.387 89.1291 149.717 82.7163",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M116.712 242.094C119.258 196.545 115.675 162.123 112.61 141.376C111.902 136.566 114.166 130.625 117.231 127.56C118.079 126.711 119.541 125.721 121.427 124.636",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M251.568 339.322C251.615 340.03 251.709 340.737 251.756 341.444M251.803 341.444C253.312 358.183 254.35 369.925 254.444 372.376M237.94 372.235H237.186",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeDasharray: "11.32 5.68"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M235.347 340.124C235.064 337.153 234.828 334.088 234.498 330.929C233.131 315.557 231.48 297.969 229.783 280.24C228.981 271.847 228.18 263.5 227.378 255.296C226.482 245.677 225.539 236.34 224.738 227.617C223.889 218.941 223.087 210.925 222.38 203.852C221.154 191.309 220.211 181.926 219.787 177.635C219.645 176.173 219.551 175.324 219.551 175.136C219.174 172.071 220.682 171.835 222.238 171.741C223.276 171.741 231.009 171.081 233.319 170.986C235.253 170.892 236.149 171.646 236.29 173.533C236.337 174.146 236.384 174.853 236.432 175.56C236.526 176.173 236.573 176.833 236.62 177.541C237.139 183.953 237.988 193.007 238.931 203.71C239.544 210.265 240.204 217.432 240.911 224.976C241.666 233.181 242.467 241.857 243.269 250.675C244.683 265.528 246.145 280.947 247.512 295.612C249.021 311.644 250.436 326.78 251.568 339.322",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M237.942 371.622C237.471 364.596 236.527 353.515 235.349 340.124",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeDasharray: "11.32 5.68"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M219.786 177.635C217.806 177.824 215.401 177.305 215.118 174.146C214.883 171.034 214.6 169.478 214.6 166.366C214.6 164.574 215.496 161.462 217.9 158.963C219.739 156.982 222.474 155.426 226.341 155.238C228.463 155.143 230.537 155.756 232.282 156.746C235.536 158.538 237.799 161.65 237.987 164.102C238.176 167.073 238.553 171.27 238.553 172.448C238.553 173.627 238.318 175.466 236.431 175.56",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M133.875 118.788L102.471 110.772L98.4635 109.735L84.3647 113.46V114.45L102.471 119.401L121.427 124.635H121.474",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M102.471 119.401C102.33 120.438 101.057 120.91 99.925 120.957C99.6892 120.957 99.4534 120.957 99.1705 121.004C94.7381 121.146 86.2035 121.476 82.9028 121.57H82.054C79.6492 121.57 77.9988 119.495 77.8574 116.713C77.7159 113.979 78.9891 106.67 80.9223 103.746C82.9028 100.823 86.4392 99.031 91.1545 99.2196C95.8698 99.3611 97.6616 100.351 98.9348 101.954C100.255 103.605 101.764 106.764 102.471 110.772",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M359.643 261.425C355.069 249.165 349.033 233.369 345.025 223.42",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M344.979 223.374C343.564 219.79 342.433 217.008 341.678 215.405C339.934 211.632 337.199 208.709 333.945 206.87C329.419 204.324 323.854 203.899 318.432 206.257C317.913 206.493 317.442 206.729 317.017 207.011C309.001 211.585 309.237 221.959 311.972 229.221C316.169 240.443 322.393 257.324 327.862 271.753C331.399 281.136 334.558 289.388 336.586 294.386C336.963 295.188 337.246 295.942 337.529 296.555C344.885 313.624 359.031 308.626 366.952 302.732C373.507 297.828 395.103 281.23 407.928 267.65C410.616 264.868 412.879 262.18 414.577 259.776C417.312 257.701 420.094 255.296 422.64 252.467C425.799 248.93 428.44 244.64 429.901 239.264C431.175 234.549 431.505 229.032 430.467 222.431C427.968 226.721 424.385 232.71 419.905 235.068C419.151 235.492 418.349 235.775 417.547 235.963C417.547 235.303 417.547 234.643 417.547 234.077C417.406 231.578 416.557 229.881 415.52 229.221C414.435 228.56 413.209 228.938 412.549 230.682C411.04 234.502 406.938 241.575 406.042 243.036C405.193 244.498 404.297 246.856 404.297 248.317C404.297 249.779 403.119 251.571 401.657 252.75C400.195 253.929 373.412 272.13 370.489 273.591C367.518 275.1 364.217 273.969 363.133 270.951C362.143 268.263 360.964 265.01 359.644 261.473",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M237.987 164.102C245.909 166.129 255.575 169.194 265.808 172.872C271.23 174.852 276.841 176.974 282.358 179.238C286.178 180.794 289.997 182.397 293.722 184.047C299.899 186.782 305.84 189.611 311.31 192.488C320.646 197.344 328.615 202.248 333.944 206.869",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M236.622 177.541C241.856 179.097 248.505 181.549 255.86 184.425C278.352 193.148 306.927 205.549 317.018 207.011",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M327.861 271.752C326.682 275.241 324.843 286.369 323.334 296.554C322.061 305.372 321.071 313.435 321.071 315.086C321.071 318.669 321.637 323.762 322.627 326.308C324.042 329.986 324.749 337.625 324.466 347.81C324.325 352.431 324.042 357.617 323.523 363.182C322.863 370.585 321.825 378.695 320.364 387.182C318.148 400.527 314.894 414.861 310.509 428.818C309.566 431.883 308.575 434.901 307.538 437.872",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M323.383 296.556C324.892 298.017 326.259 299.668 327.579 301.46C333.992 310.136 338.377 322.584 339.651 339.182C339.933 342.718 340.075 346.443 340.028 350.357C340.028 357.666 339.415 365.635 338.236 374.311C336.397 387.844 333.049 403.074 327.957 420.049C327.202 422.69 326.353 425.425 325.458 428.16",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M255.859 184.424C251.663 189.281 249.918 195.034 250.201 202.767C250.295 205.879 250.767 209.368 251.521 213.282C252.087 216.205 252.464 219.506 252.794 222.713C253.077 225.73 253.313 228.701 253.549 231.153C253.737 232.945 253.926 239.358 253.973 247.798C254.115 263.406 253.879 285.85 252.37 298.676",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M287.546 141.515C287.074 150.945 289.432 159.15 293.959 164.997C290.516 170.372 284.952 176.974 282.359 179.237",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M311.311 192.487C313.952 188.008 317.206 185.509 321.591 185.886C326.023 186.263 329.843 183.198 331.587 180.133C333.285 177.068 335.407 170.939 340.405 169.005C339.839 161.508 339.745 155.189 340.028 148.682C340.971 126.803 328.994 118.929 315.838 116.618C301.456 114.119 289.008 124.304 287.641 139.865C287.641 140.383 287.546 140.949 287.546 141.468",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M195.975 248.128C196.777 251.476 197.248 253.786 197.295 254.211C197.484 255.531 196.918 257.228 194.608 257.464C188.242 258.03 173.483 263.971 169.664 272.223C168.957 273.779 166.787 274.675 165.42 273.402C162.119 270.196 148.634 255.295 144.531 250.721C143.4 249.495 142.409 248.128 141.561 246.619C136.515 238.037 135.478 225.636 139.91 218.139C140.382 217.384 140.853 216.583 141.325 215.828C144.767 210.217 149.388 203.993 152.783 201.824C156.602 199.325 163.534 198.099 169.098 201.258C172.163 203.003 177.303 207.105 181.688 212.433C183.621 214.696 185.319 217.243 186.686 219.93C186.686 219.978 186.686 219.978 186.686 220.025C190.788 228.229 194.183 240.725 195.928 248.128H195.975Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M181.689 212.434C180.463 210.972 175.936 210.972 173.107 213.141C165.232 219.083 157.971 229.645 156.98 238.651C156.462 243.791 156.226 252.278 156.792 255.72",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M195.976 248.129C199.276 251.194 204.18 256.664 207.339 260.342C208.613 261.804 209.556 262.983 210.074 263.643C210.97 264.35 211.96 265.152 212.998 266.048C213.469 266.425 213.988 266.849 214.507 267.274C220.307 272.036 227.379 277.836 229.784 280.241",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M247.512 295.611C248.691 296.696 250.106 297.922 251.709 299.384C251.709 299.431 251.803 299.478 251.85 299.525C261.658 308.437 278.162 323.95 291.789 345.028C298.626 355.543 304.756 367.472 308.953 380.675C309.99 383.882 310.886 387.182 311.687 390.53",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M327.956 420.049C359.831 404.112 406.182 381.29 409.955 379.545C415.519 376.999 419.762 371.01 421.46 364.173C423.205 357.336 426.6 343.661 427.873 335.127C428.533 330.789 428.769 326.356 428.391 322.065C428.344 321.452 428.25 320.887 428.156 320.274C426.977 311.409 422.733 303.581 413.35 300.045C411.133 299.196 406.512 296.556 406.512 296.556",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M181.404 315.085C188.665 325.317 195.974 335.927 202.623 345.923C210.073 357.098 216.674 367.472 221.437 375.724C238.978 406.043 260.338 426.979 268.024 432.967C275.71 438.956 290.233 439.805 298.39 435.136C299.852 434.288 304.237 431.977 310.509 428.818",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M174.331 305.231C176.17 307.73 178.009 310.323 179.895 312.917",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M141.56 246.619C140.239 254.305 139.768 260.765 144.908 266.706C151.415 274.251 162.213 288.397 173.907 304.617",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M214.506 267.272C214.034 266.8 213.563 266.376 212.997 266.046C200.502 257.652 162.638 271.091 174.426 297.072",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M291.554 383.411C292.732 385.392 293.534 387.278 294.1 389.07C300.088 407.931 276.842 417.786 266.798 410.194C266.374 409.864 265.949 409.487 265.572 409.11",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M251.758 341.445H251.806",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M178.293 303.062C178.671 303.534 179.095 304.052 179.614 304.618C181.783 307.259 184.989 310.937 188.856 315.416C200.833 329.232 219.599 350.781 237.188 372.235C248.127 385.533 258.642 398.83 266.8 410.194C270.43 415.239 273.59 419.86 276.136 424.009C281.276 432.308 291.272 438.863 298.392 435.137",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6229 160.377C44.8978 155.521 41.9744 152.786 39.5696 150.994C36.5046 148.683 30.9406 143.497 27.687 142.129C17.502 138.027 8.54291 144.675 6.98686 148.306C1.61143 160.566 -1.45352 178.201 3.49754 193.196C4.77067 196.921 6.32672 199.42 9.06159 200.882C9.91035 201.4 10.8534 201.731 11.9379 202.013C16.5589 203.145 26.5553 207.766 29.1959 211.208C31.8836 214.65 34.8071 212.151 36.1274 210.077C40.2297 203.475 49.566 199.703 58.7608 200.457C61.4485 200.693 63.0517 199.326 62.5802 197.015C62.1558 194.799 61.6843 192.63 61.2599 190.555C58.9966 179.993 56.356 171.175 51.8765 164.81C50.7448 163.207 49.6603 161.745 48.6701 160.425C48.6701 160.425 48.6701 160.425 48.6701 160.377C43.2475 156.464 20.9441 156.699 19.7653 190.697",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M162.731 369.641C167.494 368.085 171.36 365.916 174.237 364.313C183.856 358.938 195.456 352.148 202.623 345.923",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16.228 226.673C19.5759 234.501 24.0083 242.375 29.6195 251.146C41.1248 269.158 88.3249 334.795 116.334 357.806C135.808 373.791 151.557 373.319 162.591 369.688",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06055 200.882C10.3337 210.077 12.6442 218.328 16.1806 226.58",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M132.13 258.69C147.314 273.496 162.403 289.576 173.908 304.617C174.096 304.853 174.238 305.042 174.332 305.23C174.898 305.938 175.464 306.645 175.935 307.352C177.35 309.238 178.67 311.077 179.896 312.916C180.462 313.671 180.934 314.378 181.405 315.085C176.03 317.773 159.149 324.422 157.593 321.64",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2583 190.556C65.2663 195.507 72.1978 204.324 74.5083 207.389C74.8855 207.719 75.3099 208.002 75.7343 208.379C79.4122 211.303 84.4104 215.452 90.3045 220.545C95.4442 224.883 101.244 229.976 107.421 235.492C110.156 237.992 112.938 240.538 115.767 243.131C121.143 248.082 126.612 253.316 132.129 258.645",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M157.546 321.64C160.423 326.874 162.686 332.344 164.289 337.861C167.165 347.81 159.668 361.343 145.475 359.787",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M162.733 369.641C162.733 369.641 162.639 369.688 162.592 369.688C158.914 370.678 156.603 369.217 152.407 365.869C150.332 364.218 148.021 362.191 145.475 359.786H145.428C115.439 331.919 57.6291 260.859 48.8115 253.786",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1821 226.58C16.1821 226.58 16.1821 226.627 16.1821 226.674C20.143 234.926 34.8075 245.771 36.0807 246.526C37.3538 247.28 39.1928 245.913 38.3912 244.215C28.6777 223.751 51.4054 198.194 75.6892 208.379",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9028 121.569C85.0719 138.544 89.8815 201.446 91.1546 219.553",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1694 120.957C100.395 138.734 107.233 217.149 108.27 234.548",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M238.931 203.711C243.599 203.522 247.985 203.239 250.201 202.768",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M224.739 227.617C218.561 228.56 212.997 229.362 209.932 229.645C201.492 230.399 196.494 230.399 191.543 222.713C190.93 221.77 190.175 220.356 189.279 218.564C183.244 206.068 172.352 175.89 169.664 164.809C166.599 152.125 176.171 141.752 182.725 140.243C183.338 140.101 183.951 140.007 184.611 139.96C191.071 139.3 199.842 142.789 202.294 153.257C204.934 164.809 212.243 194.704 213.799 198.571C215.308 202.39 217.996 203.805 222.381 203.852",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M252.794 222.713C250.578 223.232 246.146 224.034 240.912 224.977",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M285.99 106.482C290.847 97.7584 295.939 89.8367 300.607 83.5182C306.077 76.0209 310.934 70.7398 313.951 68.8536C325.457 61.5921 332.718 61.4978 343.846 63.101C362.283 65.7887 400.666 74.2291 413.303 79.6045C420.329 82.5752 425.845 85.9702 431.127 90.1196C435.37 93.3732 439.425 97.1454 443.999 101.483C450.742 107.849 458.192 116.808 465.454 127.465C474.743 141.045 483.749 157.36 490.445 174.382C488.512 176.457 486.484 178.343 484.551 179.946C481.816 182.304 479.317 184.143 477.761 185.51C475.073 187.821 472.385 187.821 469.698 187.443C469.556 187.396 469.415 187.396 469.273 187.396C466.633 187.255 463.049 188.952 460.88 190.508C459.843 191.263 458.711 192.111 457.532 193.055C452.628 196.827 446.546 202.108 441.076 208.002C438.954 210.313 436.926 212.717 435.087 215.169C434.097 216.537 433.107 217.951 432.258 219.366C431.598 220.356 430.985 221.393 430.466 222.431",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M282.076 113.931C283.302 111.432 284.622 108.933 285.989 106.528",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M265.809 172.873C264.819 154.767 272.411 132.982 282.03 113.932",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M465.454 127.463C473.187 130.623 480.826 134.112 483.891 140.242C487.003 146.372 493.887 159.81 495.821 163.252C497.707 166.695 494.925 169.995 490.445 174.381",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M327.578 301.46C331.539 298.913 336.018 294.858 336.584 294.387",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M339.649 339.182C347.194 333.476 369.686 308.957 374.826 304.336C379.918 299.715 386.048 297.169 390.669 297.169C394.913 297.169 400.382 296.933 406.512 296.556C429.994 295.047 462.294 291.463 464.322 291.039C466.915 290.52 469.697 291.793 470.876 293.349C472.008 294.858 482.759 295.613 483.89 287.597C484.55 283.306 485.541 269.82 486.059 262.275",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M407.927 267.651C425.986 267.604 463.567 270.291 465.878 270.716C468.188 271.093 470.876 269.537 472.008 267.226C472.856 265.529 473.799 261.144 474.884 257.654",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M422.639 252.467C431.74 253.033 448.62 255.721 451.685 256.098C454.75 256.475 456.306 255.343 457.438 253.41C457.815 252.797 458.287 251.948 458.758 251.1",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M294.101 389.068C301.598 391.52 307.162 391.52 311.689 390.53C315.084 389.823 317.866 388.502 320.365 387.182",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M308.954 380.676C308.011 377.941 317.3 368.888 323.524 363.182",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M340.027 350.356C361.529 333.476 386.567 318.67 411.134 309.946",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M338.236 374.309C352.806 360.116 388.124 335.031 419.339 322.252",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M292.497 344.556C302.163 349.365 317.11 351.959 324.466 347.809",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M207.292 260.342C212.667 259.352 223.041 256.759 227.332 255.297",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M243.317 250.674C246.807 249.59 253.314 247.986 253.974 247.798H254.021",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M431.128 90.1197C423.678 84.8858 413.728 91.9587 410.994 95.3537C397.979 111.433 387.228 125.673 379.543 138.687C378.081 141.139 376.666 144.157 375.252 147.552C369.216 162.217 363.841 184.001 362.285 197.393C360.351 213.896 358.182 241.811 359.644 261.426",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M234.783 78.9912C225.07 86.6771 216.865 98.5597 212.385 113.036C207.387 129.115 208 145.1 212.951 157.501",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M266.845 70.5505C259.3 68.6172 251.379 69.7489 243.881 73.3325",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M287.97 87.6205C285.99 84.0368 283.585 80.8776 280.803 78.2842",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M250.955 102.05C262.413 105.398 277.502 110.302 282.028 113.932H282.076",
    stroke: "#909090",
    strokeWidth: 1.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M237.754 86.582C236.339 87.808 234.972 89.1754 233.652 90.6372C231.058 93.4192 232.567 97.2386 237.565 98.4174C238.084 98.5589 238.933 98.7475 240.064 99.0304",
    stroke: "#909090",
    strokeWidth: 1.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M270.195 80.1696C268.922 79.4624 267.601 78.8965 266.187 78.4721C259.915 76.5389 253.267 77.3876 246.948 80.4526",
    stroke: "#909090",
    strokeWidth: 1.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M285.989 106.529C285.565 103.653 284.904 100.965 284.056 98.4189",
    stroke: "#909090",
    strokeWidth: 1.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M215.684 32.1672L223.606 30.894",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M225.918 37.2612L237.424 37.0254",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M239.214 30.0928L249.965 31.6488",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M254.304 38.8169C257.888 38.8169 263.782 40.3258 265.574 40.8445",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M268.119 50.8398C271.702 51.5943 277.078 53.3861 278.634 53.9048",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M237.186 48.0105C240.77 48.0105 249.729 47.7747 252.039 48.2934",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M243.317 62.582C248.457 62.582 257.133 62.582 261 63.3836",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M276.842 65.4116C281.935 66.6848 286.32 68.7595 288.112 69.7497",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M253.312 86.3936C258.923 86.3936 267.882 86.9122 270.193 87.4309",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M283.727 88.7051L286.792 89.4595",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M256.096 112.233C262.509 112.469 271.232 112.752 273.259 112.987",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M253.549 133.972C258.17 134.727 263.027 134.727 265.573 134.727",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M246.382 148.307C250.484 149.062 256.614 150.335 259.679 150.618",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M425.186 93.7979C427.779 95.8726 433.626 101.484 434.946 102.993",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M416.367 100.445C419.338 102.614 426.081 109.404 427.637 111.196",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M409.483 108.885C411.888 110.819 418.065 116.335 420.234 118.222",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M399.77 119.4C402.929 121.192 410.096 124.87 412.784 126.945",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M392.461 132.934C395.904 134.49 403.448 139.441 405.9 140.856",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M384.682 150.476C389.02 152.362 397.837 156.228 400.384 157.266",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M375.958 166.979C380.673 168.771 389.161 170.799 391.943 171.176",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M373.412 181.266C378.127 182.303 384.398 183.576 386.944 183.718",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M371.998 195.978C376.336 196.78 384.541 197.393 387.37 197.393",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M369.309 213.283C373.647 213.66 380.578 214.556 384.398 214.65",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M367.14 228.373C371.478 228.608 377.372 228.891 380.437 228.986",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M366.387 239.594C370.348 239.736 376.336 239.877 380.439 239.736",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M366.905 252.042C371.621 252.137 376.713 251.901 378.505 251.901",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M365.583 262.888C369.45 262.888 374.543 263.265 375.957 263.171",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M353.561 225.306C350.166 224.787 346.96 224.08 345.027 223.42H344.979",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M353.844 208.661C350.402 207.907 343.329 205.596 341.443 204.559",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M343.091 188.056C345.92 189.612 351.673 191.545 354.361 192.158",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M344.224 173.863C347.808 175.514 353.985 177.824 356.531 178.484",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M349.08 156.605C353.182 158.397 359.454 161.32 361.764 162.122",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M356.248 138.167C360.491 140.383 365.867 142.788 368.649 143.92",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M364.453 123.738C368.65 125.011 374.685 127.18 376.854 127.935",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M373.646 110.159C377.513 110.96 383.643 112.092 386.708 113.129",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M381.191 99.3145C385.812 100.069 391.942 101.719 394.017 102.521",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M391.329 90.874C396.705 91.7699 401.939 92.9016 404.108 93.7975",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M399.864 82.9512C404.343 84.0828 410.756 86.1104 412.406 87.0063",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M183.856 54.6593C184.469 54.2349 185.082 53.8577 185.742 53.5276C187.628 52.4431 189.75 51.6415 191.966 51.0757C207.244 47.2091 228.651 55.2251 239.214 75.8781C240.392 78.1414 241.43 80.5934 242.278 83.1397C244.07 88.2793 245.202 94.0791 245.532 100.492C246.334 114.355 243.363 131.141 234.875 150.993",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M224.928 28.585C239.216 31.7914 250.344 38.6285 258.784 47.7762C265.385 54.9906 270.289 63.6668 273.637 73.0974C275.052 77.1525 276.183 81.3963 277.032 85.6872C278.305 91.9585 278.918 98.4656 279.013 104.926",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M137.223 117.798C139.911 100.021 144.909 84.8849 151.746 72.295C152.076 71.682 152.406 71.0691 152.736 70.4561C169.9 39.8066 197.39 24.9535 224.833 24.4348C227.804 24.3405 230.775 24.4348 233.745 24.7177C268.686 27.9241 293.582 43.909 300.608 83.5174",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M293.958 164.997C296.882 164.809 301.456 166.035 305.558 168.534C308.67 170.42 311.499 172.966 313.15 176.173",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M308.294 122.465C303.437 127.322 300.891 138.072 304.192 151.087C304.333 151.605 304.474 152.171 304.569 152.784C305.653 158.207 305.842 165.327 305.559 168.533C302.683 172.824 296.553 181.453 293.724 184.047",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M278.258 199.703C272.882 212.01 263.593 248.837 266.328 302.167",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M134.347 244.593C133.969 249.214 133.026 255.108 132.13 258.644",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M151.415 103.792C154.15 103.792 156.932 104.453 159.714 105.773C166.504 108.979 172.87 116.099 176.17 126.426",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M173.106 61.166C161.601 66.9658 159.196 79.1784 160.658 89.222C161.224 93.23 160.563 101.105 159.715 105.773C154.104 115.863 151.463 121.427 147.785 126.992C142.221 135.432 133.592 156.132 134.158 173.437C134.724 190.695 135.902 206.821 136.28 213.894",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M149.718 82.668C149.718 84.0354 152.453 86.1101 154.292 87.1003",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M160.657 89.2231C167.541 92.2881 186.544 94.5514 195.55 93.6084",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M287.546 141.469C287.546 143.166 291.79 147.457 297.26 149.626",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M304.568 152.785C309.802 156.133 317.016 158.302 331.209 156.84",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseSafetyAirbags3);
export default __webpack_public_path__ + "static/media/eclipse-safety-airbags-3.0ccf3cc3b3292aa8c62e78290f8d06e9.svg";
export { ForwardRef as ReactComponent };